// extracted by mini-css-extract-plugin
export default {"enddate":"endDate_enddate__IfjsV","enddate-banner":"endDate_enddate-banner__JiSIo","enddate__days-left":"endDate_enddate__days-left__DxURD"};